'use strict';

var React = require('react'),
    ContextMenu = require('../molecules/ContextMenu'),
    StampDraftStore = require('../stores/StampDraftStore'),
    StampStore = require('../stores/StampStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    Link = require('../atoms/Link'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    parseStampSegment = require('../utils/parseStampSegment'),
    { PropTypes } = React,
    DraftActionCreators = require('../actions/DraftActionCreators');

var EditorMoreContextMenu = React.createClass({
  mixins: [createStoreMixin(StampDraftStore, StampStore), PureRenderMixin],

  propTypes: {
    stampSegment: PropTypes.string.isRequired,
    anchorRect: PropTypes.object.isRequired
  },

  getStateFromStores(props) {
    const { stampId, draftUuid } = parseStampSegment(props.stampSegment);
    return {
      draft: StampStore.get(stampId || draftUuid)
    };
  },

  componentDidMount() {
    const { isDraft, draftUuid } = parseStampSegment(this.props.stampSegment);

    if (isDraft) {
      DraftActionCreators.requestDraftFeedbackPage(draftUuid, true);
    }
  },

  render() {
    const { stampSegment } = this.props;
    const { isDraft } = parseStampSegment(stampSegment);
    const { draft } = this.state;

    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        {isDraft && draft.feedbackCount > 0 &&
          <Link propagateClick
                onClick={this.handleShowFeedbacksClick}
                context='contextMenu'
                underline='never'>
            Feedback <span className='Counter'>{draft.feedbackCount}</span>
          </Link>
        }

        {isDraft &&
          <Link propagateClick
                onClick={this.handleShareDraftClick}
                context='contextMenu'
                underline='never'>
            Share Draft
          </Link>
        }

        <Link propagateClick
              onClick={this.handleDeleteClick}
              context='contextMenu'
              underline='never'
              color='red'>
          {isDraft ?
            'Delete Draft' :
            'Delete Stamp'
          }
        </Link>
      </ContextMenu>
    );
  },

  handleDeleteClick() {
    const { stampSegment } = this.props;
    const { isDraft, draftUuid, stampId } = parseStampSegment(stampSegment);

    if (isDraft) {
      AlertActionCreators.showAlert(AlertTypes.DELETE_DRAFT, { draftUuid });
    } else {
      AlertActionCreators.showAlert(AlertTypes.DELETE_STAMP, { stampId });
    }
  },

  handleShowFeedbacksClick() {
    const { stampSegment } = this.props;
    const { draftUuid } = parseStampSegment(stampSegment);

    SidebarActionCreators.showSidebar(SidebarTypes.DRAFT_FEEDBACKS, { draftUuid });
  },

  handleShareDraftClick() {
    const { stampSegment } = this.props;
    const { draftUuid } = parseStampSegment(stampSegment);

    AlertActionCreators.showAlert(AlertTypes.SHARE_DRAFT, { draftUuid });
  }
});

module.exports = EditorMoreContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/EditorMoreContextMenu.jsx
 **/